import { Inject, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { Title } from '@angular/platform-browser';
import { IoniScriptEngine, LionEngine } from './engine/io-engine';
import { ThemeService } from './theme.service';
import { IoniScriptManager, RunStatus } from './engine/io-manager';
import { IoniScriptFile } from './engine/lion-file';
import { AuthService } from './onedrive/auth.service';
import { OidcAuthService, AuthUser } from './auth/oidc-auth.service';
import { OAuthSettings } from './onedrive/oath.settings';
import { PubComponent } from './published-lionscript/pub-component';
import { PubDirective } from './published-lionscript/pub.directive';
import { WidgetFactory } from './widget-factory';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GraphService, ProviderOptions } from './onedrive/graph.service';


import {
  AuthenticationResult,
  InteractionStatus,
  InteractionType,
  PopupRequest,
  RedirectRequest,
  AccountInfo,
  EventMessage,
  EventType
} from '@azure/msal-browser';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { clearStorage } from './onedrive/storage-utils';
import { b2cPolicies, protectedResources, rarePolicies } from './onedrive/auth-config';



@Component({
  selector: 'app-dialog',

  template: `                    
  <ng-template pub-modal> </ng-template>
  `,
})
export class App implements OnInit, IoniScriptManager {

  @ViewChild(PubDirective, { static: false }) compService: PubDirective | undefined;
  widgets = {}
  widget = null;
  test = 'Standby... not implemented yet. ';

  constructor(

    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<App>,
    private zone: NgZone) {
  }
  ngOnInit(): void {
  }

  showWidget(js: any): Promise<{}> {
    throw new Error('Method not implemented.');
  }

  loadWidget(wid: {}, resolve: any) {
    let type = wid["wid"];
    if (type == null) type = wid["type"];

    let line = wid["input"];
    let title = wid["title"];
    if (line == undefined || line == null) {
      line = wid["data"];
    }

    if (wid['componentRef'] === 'testing') {
      debugger;
      // alert('testing')
    }

    let pubcomp = WidgetFactory.createWidget(type);
    let viewContainerRef = this.compService.viewContainerRef;
    let componentRef = viewContainerRef.createComponent(pubcomp);
    if (line != undefined) (<PubComponent>componentRef.instance).data = line;
    (<PubComponent>componentRef.instance).resolveFunction = resolve;
    (<PubComponent>componentRef.instance).title = title;
    (<PubComponent>componentRef.instance).init(this);
    if (wid["id"] != undefined) {
      if (this.widgets == null) {
        this.widgets = {};
      }
      this.widgets[wid["id"]] = {
        instance: <PubComponent>componentRef.instance,
        wid: type,
      };
    }
    (<PubComponent>componentRef.instance).init(this);

    if (wid["componentRef"] != null) {
      LionEngine.componentRefs[wid['componentRef']] = {
        'viewContainerRef': viewContainerRef,
        'components': [(<PubComponent>componentRef.instance)]
      }
      this.zone.run(() => {
        this.dialogRef.close();
      })
    }

    if (wid['refCallback'] != null) {
      LionEngine.ionfunctions[wid['refCallback']](<PubComponent>componentRef.instance);
    }



    return (<PubComponent>componentRef.instance);
  }
  POSTFile(file: any, url: string): Promise<string> {
    throw new Error('Method not implemented.');

  }
  getScript(): string {
    throw new Error('Method not implemented.');

  }
  setScript(script: string) {
  }
  showFile(lf: IoniScriptFile) {
  }
  log(line: string) {
  }
  getIonisFS() {
  }
  getAccessToken(): string {
    throw new Error('sadfgasdfasdf asdf asdf asdfasdf asdf asdf asdf asdf asdfasd fMethod not implemented.');

  }
  setIonisFS(jsonObject: any) {
  }
  createObject(object_type: any, object_config: any): Promise<any> {
    throw new Error('Method not implemented.----------------------------------------------------------- ');

  }
  updateProgress(progress: string): void {
  }
  save(path: string, name: string, type: string, rule: string, input: string, callback: any) {
  }
  resetLog() {
  }
  removeComponent(index: any) {
  }
  getComponentCount(): Number {
    throw new Error('Method not implemented.');
  }
  voiceToText(listener) {
  }

  displayApp(title: any, url: any): Promise<string> {
    throw new Error('Method not implemented.');
  }
  showInputItem(title: any): Promise<{}> {
    throw new Error('Method not implemented.');
  }
  showInputTextArea(title: any): Promise<{}> {
    throw new Error('Method not implemented.');
  }
  showMenu(menuconfig: any): Promise<{}> {
    throw new Error('Method not implemented.');
  }
  clearMenu(): Promise<{}> {
    throw new Error('Method not implemented.');
  }
  showNavbar(navbarconfig: any): Promise<{}> {
    throw new Error('Method not implemented.');
  }
  showFooter(menuconfig: any): Promise<{}> {
    throw new Error('Method not implemented.');
  }
  showInputParamPair(title: any, label: string[]): Promise<{}> {
    throw new Error('Method not implemented.');
  }
  displaySVG(url: any, json: any): Promise<string> {
    throw new Error('Method not implemented.');
  }
  showOKPanel(msg: string): Promise<string> {
    throw new Error('Method not implemented.');
  }
  updateUI(ui_item_name: any, item_field: any, item_value: any) {
    throw new Error('Method not implemented.');
  }
  clearWeak(): Promise<{}> {
    throw new Error('Method not implemented.');

  }
  isModal(): boolean {
    throw new Error(' not implemented ')

  }

  showModal(js: any, width: number, height: number): Promise<{}> {
    throw new Error(' not implemented ')
  }
  hideAllModal(): void {
    throw new Error('Method not implemented.');
  }
  setUIObject(obj: any, objectlabel: string, objtype: string) {
    throw new Error('Method not implemented.');
  }
  statusChanged(st: RunStatus): void {
    throw new Error('Method not implemented.');
  }
  micOff() {

  }



}




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  @Input('lg')
  lg = false;
  user = null;
  host: string = null;
  ready = true;
  showLJW = false;
  buttons = []
  showToolbar = true;
  isIframe = false;
  name: string | undefined;
  accounts: AccountInfo[] = [];
  canSignUp = false;
  fg = 'white';
  bg = '#ffffff'

  // ---- Citation ------------------------------------------------------------
  // The year is taken from the clock rather than hard-coded, so the reference does not
  // quietly go stale the way a literal would.
  showCite = false;
  citeCopied = false;
  private citeYear = new Date().getFullYear();

  get citePlain(): string {
    return 'Milton, J. (' + this.citeYear + '). BajaBio GeneTx Designer '
      + '[computer software]. BajaBio, La Jolla, California. '
      + 'https://oligodesigner.com';
  }

  get citeBibtex(): string {
    return '@software{milton_bajabio_rnatx_designer,\n'
      + '  author    = {Milton, Jeff},\n'
      + '  title     = {BajaBio GeneTx Designer},\n'
      + '  year      = {' + this.citeYear + '},\n'
      + '  publisher = {BajaBio},\n'
      + '  address   = {La Jolla, California, USA},\n'
      + '  url       = {https://oligodesigner.com}\n'
      + '}';
  }

  copyCitation(text: string): void {
    const done = () => {
      this.zone.run(() => {
        this.citeCopied = true;
        setTimeout(() => this.zone.run(() => (this.citeCopied = false)), 2000);
      });
    };
    try {
      // navigator.clipboard needs a secure context; fall back so the button still
      // works over plain http rather than failing silently.
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done, () => this.copyFallback(text, done));
      } else {
        this.copyFallback(text, done);
      }
    } catch (e) {
      this.copyFallback(text, done);
    }
  }

  private copyFallback(text: string, done: () => void): void {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    } catch (e) { }
  }

  private readonly _destroying$ = new Subject<void>();

  static titleService: any;
  public constructor(private titleService: Title,
    private auth: AuthService,
    private zone: NgZone,
    private dialog: MatDialog,
    private engine: IoniScriptEngine,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private gs: GraphService,
    private theme: ThemeService,
    private oidc: OidcAuthService

  ) {
    AppComponent.titleService = titleService;
    this.host = window.location.hostname;
    IoniScriptEngine.app = this;

    // Sign out after an hour without input, in every tab. See OidcAuthService.startIdleWatch.
    try { this.oidc.startIdleWatch(); } catch (e) { console.warn('idle watch failed to start', e); }

    // Apply the saved/default theme and expose a global hook so lionscript
    // menus can switch themes, e.g. window.setTheme('dark').
    this.theme.init();
    window['setTheme'] = (id: string) => this.zone.run(() => this.theme.setTheme(id));
    window['getThemes'] = () => this.theme.themes;
    window['cycleTheme'] = () => this.zone.run(() => this.theme.cycle());
  }

  get themes() { return this.theme.themes; }
  get currentTheme() { return this.theme.getTheme(); }
  setTheme(id: string): void { this.theme.setTheme(id); }



  // ---- News ("The Baja Times") ---------------------------------------------
  // The newspaper already existed inside the editor's startup progress bar, where it showed
  // once and could not be brought back. This puts it behind a toolbar button so it can be
  // opened on demand, and renders it maximised rather than as a small card.
  showNews = false;
  newsItems: string[] = [];
  newsLoading = false;

  get newsDate(): string {
    try {
      return new Date().toLocaleDateString('en-US',
        { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) { return ''; }
  }

  // True while the paper is on screen as the LOADING SPLASH rather than because the user
  // asked for it. Only a splash is auto-dismissed; a paper the user opened stays until they
  // close it, even if the app finishes booting while they are reading.
  // Public: the template shows the press-run strip while the paper is standing in for a
  // loading screen, and hides it once the app is up.
  newsIsSplash = false;

  // Standing features, written as short dispatches. They run under the day's headlines so the
  // paper has something to READ during a boot that is usually a second or two -- and they say
  // what the app can do, which is the one thing a first-time reader is actually after.
  //
  // Every one describes something that exists today. A paper that advertises what the app
  // cannot do yet is worse than a blank page.
  featureStories: Array<{ kicker: string; headline: string; body: string }> = [
    {
      kicker: 'Design desk',
      headline: 'Oligos designed against the whole track, or just the part you picked',
      body: 'siRNA and single-stranded ASO designers run from the Design menu, with primer '
        + 'pairs from primer3 and djPrimer alongside them. Select a stretch of sequence first '
        + 'and the design is confined to it; select nothing and it runs the length of the track.'
    },
    {
      kicker: 'Off-target bureau',
      headline: 'Seventeen indexes stand between a candidate and a surprise',
      body: 'Every design can be swept against human, mouse, rat, dog, cynomolgus and rhesus '
        + 'sequence, in both cDNA and pre-mRNA form, so a site that looks clean in one species '
        + 'can be checked in the animal it will be tested in before anyone orders it.'
    },
    {
      kicker: 'Models',
      headline: 'Splicing, RNA-binding and intron retention, scored on the canvas',
      body: 'BajaSplice scores splice-site strength and PSI, BajaCLIP predicts where an '
        + 'RNA-binding protein footprints, and BajaIR ranks introns by how retention-prone '
        + 'they are. Each writes its answer onto the track as a layer you can keep or remove.'
    },
    {
      kicker: 'Data desk',
      headline: 'Patents and miRNA sites arrive as layers, not as a separate search',
      body: 'Published patent claims and experimentally reported miRNA target sites drop onto '
        + 'the transcript in place, so an oligo can be read against the IP and the regulation '
        + 'covering the same bases. RNASeq coverage loads the same way.'
    }
  ];

  private newsSplashTimer: any = null;

  // Show the paper while the app boots, and take it away once the app is up.
  //
  // Startup is the one moment there is nothing to look at and a wait to fill, so the news
  // reads as a splash rather than an interruption. Not shown on the sign-in or checkout
  // pages: those are not the app booting, and the paper would cover the thing being asked for.
  private startNewsSplash(): void {
    try {
      const p = ('' + window.location.pathname).toLowerCase();
      if (/^\/(login|auth|subscribe|signup)(\/|$)/.test(p)) return;
      // gene.clinic is a clinical sign-in, not the Baja app booting: no "Baja Times" splash
      // there, including at the root that redirects to the sign-in (and /login, /subscribe).
      const host = ('' + window.location.hostname).toLowerCase();
      if (host.indexOf('gene.clinic') >= 0) return;

      this.newsIsSplash = true;
      this.openNews();

      // "Up" is the lionscript canvas existing: every host in this app draws onto one, so it
      // is the signal that does not need each host to announce itself. __bajaAppReady is
      // honoured too, for a host that wants to say so explicitly.
      //
      // The deadline is not a fallback, it is the guarantee: if the app never finishes, or
      // finishes in a way this cannot see, the paper still goes away rather than sitting over
      // a dead page.
      const t0 = Date.now();
      const onSignInPage = () => {
        try {
          const pp = ('' + window.location.pathname).toLowerCase();
          const hh = ('' + window.location.hostname).toLowerCase();
          return /^\/(login|auth|subscribe|signup)(\/|$)/.test(pp) || hh.indexOf('gene.clinic') >= 0;
        } catch (e) { return false; }
      };
      const tick = () => {
        if (!this.newsIsSplash) return;              // the user took it over
        // If the view has moved to sign-in or checkout (e.g. the root redirected to /login,
        // or the user navigated there), take the paper down at once — "the presses are
        // running" must never sit over the sign-in.
        let ready = false;
        try { ready = !!document.querySelector('canvas') || !!(window as any).__bajaAppReady; } catch (e) { }
        if (ready || onSignInPage() || (Date.now() - t0) > 12000) {
          this.newsIsSplash = false;
          this.zone.run(() => (this.showNews = false));
          return;
        }
        this.newsSplashTimer = setTimeout(tick, 250);
      };
      // A beat before the first readiness check: the canvas can exist before anything is
      // drawn on it, and closing in the same frame it appears makes the paper flash.
      this.newsSplashTimer = setTimeout(tick, 1200);
      // But watch for a SIGN-IN redirect straight away, not on that beat: the root of the app
      // boots the paper and then bounces an anonymous visitor to /login (or /subscribe), so
      // without this the paper flashes over the sign-in for over a second. Polls fast for a
      // few seconds and takes the paper down the instant the view is a sign-in/checkout page.
      const signInWatch = () => {
        if (!this.newsIsSplash) return;
        if (onSignInPage()) {
          this.newsIsSplash = false;
          this.zone.run(() => (this.showNews = false));
          return;
        }
        if (Date.now() - t0 < 4000) setTimeout(signInWatch, 100);
      };
      setTimeout(signInWatch, 60);
    } catch (e) { }
  }

  // Called from the toolbar button. Hands the paper to the user: it stops being a splash, so
  // the boot watcher leaves it alone.
  // The tutorials live as a static page under /assets, so this is a plain navigation
  // rather than anything the app has to render. noopener because it is a new tab and the
  // opened page has no business reaching back into this one.
  openTutorials(): void {
    try {
      window.open('assets/tutorials.html', '_blank', 'noopener');
    } catch (e) {
      window.location.href = 'assets/tutorials.html';
    }
  }

  openNewsFromButton(): void {
    this.newsIsSplash = false;
    try { clearTimeout(this.newsSplashTimer); } catch (e) { }
    this.openNews();
  }

  closeNews(): void {
    this.newsIsSplash = false;
    try { clearTimeout(this.newsSplashTimer); } catch (e) { }
    this.showNews = false;
  }

  async openNews(): Promise<void> {
    this.showNews = true;
    if (this.newsItems.length || this.newsLoading) return;
    this.newsLoading = true;
    try {
      const host = (window['env'] && window['env']['apiUrl']) || window.location.origin;
      const r = await fetch(host + '/news-headlines');
      const j = r.ok ? await r.json() : null;
      this.zone.run(() => {
        this.newsItems = (j && Array.isArray(j.items)) ? j.items : [];
        this.newsLoading = false;
      });
    } catch (e) {
      // An empty paper says "nothing today", which is honest; a spinner that never resolves
      // would not be.
      this.zone.run(() => { this.newsItems = []; this.newsLoading = false; });
    }
  }

  // ---- Free-plan bar -------------------------------------------------------
  // Rendered HERE, in the app shell, rather than by the lionscript module it lived in before.
  // That module was correct in isolation -- it compiled and rendered under the engine's own
  // pipeline -- but it never appeared in the running app, and every layer between the two
  // (exec, the script cache, the editor's own re-mounts) swallows errors silently, so there
  // was nothing to follow. The shell is the one layer that is provably running: it draws the
  // toolbar the user is already looking at. No exec, no compile step, no DOM node appended
  // from outside Angular's lifecycle for a later re-mount to take away.
  freeBar: any = null;
  freeBarCollapsed = false;
  private freePollTimer: any = null;
  // When the subscription first failed to validate, and how many tries have failed since.
  private freeFailSince = 0;
  private freeFailTries = 0;

  private async checkFreePlan(): Promise<void> {
    try {
      // Only inside the app itself; the marketing and auth pages are not "the editor".
      //
      // This was an allow-list of '/app/', but nginx routes SIX prefixes to this shell
      // (app, edit, lft, books, doc, _app -- see conf.d/oligodesigner.conf) plus the root.
      // A subscriber opening the editor on any of the others got no badge at all, because
      // the check returned before it ever asked /free-quota.
      //
      // Inverted: name the pages that are NOT the app. Those are enumerable and stable --
      // sign-in, the OIDC callback and checkout -- and anything new in the shell is the app.
      const __path = ('' + window.location.pathname).toLowerCase();
      if (/^\/(login|auth|subscribe|signup)(\/|$)/.test(__path)) return;
      const host = (window['env'] && window['env']['apiUrl']) || window.location.origin;
      const u = this.oidcUser;
      const email = (u && u.email) || '';
      const r = await fetch(host + '/free-quota?user=' + encodeURIComponent(email));
      if (!r.ok) { this.onFreeCheckFailed(); return; }
      const q = await r.json();
      if (!q) { this.onFreeCheckFailed(); return; }
      // Answered: whatever it says, validation is working again.
      this.freeFailSince = 0;
      this.freeFailTries = 0;

      // flexigraph/gene.js runs its own two-try subscription check and sets these when it
      // concludes the user is not on a subscription. Honoured here because the badge is drawn
      // by the shell: without this, gene.js could reach that conclusion and nothing would show.
      let flagged = false, unverified = false;
      try {
        flagged = !!(window as any).__bajaFreeTier;
        unverified = !!(window as any).__bajaFreeUnverified;
      } catch (e) { }

      if (q.subscribed) {
        // The live answer wins over a stale flag: a subscriber who tripped gene.js during a
        // network wobble gets the badge cleared here rather than carrying it for the session.
        try { (window as any).__bajaFreeTier = false; (window as any).__bajaFreeUnverified = false; } catch (e) { }
        this.zone.run(() => (this.freeBar = null));
        return;
      }
      this.zone.run(() => {
        // Going from subscribed to not-subscribed is news: un-collapse so the badge is seen
        // rather than restored as a corner tab the user already dismissed this session.
        if (!this.freeBar) this.freeBarCollapsed = false;
        // USED, AND A LIMIT PER METRIC.
        //
        // This read `designRemaining` and `offtargetRemaining` into fields the template
        // rendered as "n/limit", so the numerator counted DOWN while the label said used.
        // It also used one `limit` for both counters, taken from the server's legacy single
        // figure, which is the design allowance. Off-target therefore showed remaining over
        // the wrong limit: "Off-target 100/5" for someone who had run nothing.
        //
        // The server sends `design` and `offtarget` as the counts actually used, and
        // `designLimit` / `offtargetLimit` alongside them. Use those, and fall back to
        // deriving used from remaining only if an older server is answering.
        const __n = (v: any, d: number) => (v != null && !isNaN(+v)) ? +v : d;
        const __designLimit = __n(q.designLimit, __n(q.limit, 5));
        const __otLimit = __n(q.offtargetLimit, __n(q.limit, 5));
        this.freeBar = {
          designLimit: __designLimit,
          otLimit: __otLimit,
          design: q.design != null ? __n(q.design, 0)
            : Math.max(0, __designLimit - __n(q.designRemaining, __n(q.aiRemaining, __designLimit))),
          ot: q.offtarget != null ? __n(q.offtarget, 0)
            : Math.max(0, __otLimit - __n(q.offtargetRemaining, __otLimit)),
          resetsOn: q.resetsOn || '',
          // Only "unverified" when a check actually failed to answer -- a plain non-subscriber
          // is not unverified, and saying so would be wrong.
          unverified: unverified && flagged
        };
      });
    } catch (e) {
      this.onFreeCheckFailed();
    }
  }

  // Validation failed. Stay quiet at first, then fall back to FREE USE.
  //
  // A single failure means nothing -- a blip should not put an upgrade bar in front of someone
  // who pays -- so the first three minutes of failures are ignored. Past that the endpoint is
  // not coming back on its own, and the honest position is that the subscription is UNPROVEN:
  // the user keeps working with the free-tier allowance and can see why, rather than silently
  // holding paid access on the strength of a check that has not answered since startup. The
  // metered calls are capped server-side regardless, so this only decides what is shown.
  //
  // The moment a check answers again this resets, and a subscriber's bar disappears on the
  // next poll 20 seconds later.
  private onFreeCheckFailed(): void {
    const now = Date.now();
    if (!this.freeFailSince) this.freeFailSince = now;
    this.freeFailTries++;
    const elapsed = now - this.freeFailSince;
    // Both conditions: three minutes AND several attempts, so a single slow request that
    // straddles the window cannot trip it on its own.
    if (elapsed < 180000 || this.freeFailTries < 3) return;
    try { (window as any).__bajaFreeTier = true; } catch (e) { }
    this.zone.run(() => {
      if (!this.freeBar) this.freeBarCollapsed = false;
      // The check has not answered, so the usage is unknown. Show none used against the
      // real limits rather than inventing a figure -- the bar already says "unverified",
      // and the server caps regardless of what is drawn here.
      this.freeBar = {
        designLimit: 5, otLimit: 100, design: 0, ot: 0, resetsOn: '',
        unverified: true
      };
    });
  }

  ngOnInit(): void {
    // Re-check the subscription every 20 seconds, not once at startup.
    //
    // The answer changes DURING a session and in both directions: someone subscribes in another
    // tab and the bar should go away without a reload, or a subscription lapses and the bar
    // should appear. A single check at boot also raced sign-in -- the email decides the answer
    // and is not always known on the first tick.
    //
    // checkFreePlan sets freeBar when the account is not subscribed and clears it when it is,
    // so the same poll both raises and retires the badge.
    this.startNewsSplash();
    setTimeout(() => this.checkFreePlan(), 1200);
    try {
      if (this.freePollTimer) clearInterval(this.freePollTimer);
      this.freePollTimer = setInterval(() => this.checkFreePlan(), 20000);
    } catch (e) { }

    this.canSignUp = window['env']['canSignUp'];
    if (window['env']['fg']) {
      this.fg = window['env']['fg']
    }
    if (window['env']['bg']) {
      this.fg = window['env']['bg']
    }
    // The theme name is no longer printed in the toolbar. It is a DEPLOYMENT setting
    // ("Baja Bio" in production), not information anyone using the app needs, and it sat
    // among the controls. It still selects the empty-canvas splash in manchester/editor.js.
    let t = window['env']['menu']
    for (let button of t) {
      this.buttons.push({
        label: button['label'], click: () => {
          debugger;
          IoniScriptEngine.le.exec(button['path'])
        }
      })
    }
    window.addEventListener('resize', (evgt) => {
      this.zone.run(() => { })
    });

    // Identity from OIDC (the app's real auth). This sets OAuthSettings.access_token — the email
    // that getUser() returns and that /load-file, /save-user-data, etc. key on. Previously this was
    // populated only from MSAL (setLoginDisplay / msalSubject$), so MSAL couldn't simply be turned
    // off. Read it from the OIDC session instead, so the whole MSAL boot path can stay inert.
    try {
      const ou = this.oidc.getUser();
      if (ou && ou.email) {
        OAuthSettings.access_token = ou.email;
        this.user = ou.email;
        this.name = ou.name || ou.email;
        this.lg = true;
      }
    } catch (e) { /* no OIDC session yet; guard will route to /login */ }

    this.setLoginDisplay();

    this.isIframe = window !== window.parent && !window.opener;

    // --- MSAL boot path DISABLED (app uses OIDC) --------------------------------------------
    // enableAccountStorageEvents + the inProgress$/msalSubject$ subscriptions below activated the
    // legacy MSAL b2c stack on boot. On production that stack federated through Google and, via
    // navigateToLoginRequestUrl, kept redirecting the page back to itself — re-booting mid-load and
    // discarding the opened file. Left inert; OIDC handles auth. (MsalRedirectComponent is also no
    // longer bootstrapped — see app.module.)
    // this.authService.instance.enableAccountStorageEvents();
    // this.msalBroadcastService.inProgress$
    //   .pipe(
    //     filter((status: InteractionStatus) => status === InteractionStatus.None),
    //     takeUntil(this._destroying$)
    //   )
    //   .subscribe(() => {
    //     this.setLoginDisplay();
    //     this.checkAndSetActiveAccount();
    //   });

    // this.msalBroadcastService.msalSubject$
    //   .pipe(
    //     filter(
    //       (msg: EventMessage) => msg.eventType === EventType.LOGOUT_SUCCESS
    //     ),
    //     takeUntil(this._destroying$)
    //   )
    //   .subscribe((result: EventMessage) => {
    //     this.setLoginDisplay();
    //     this.checkAndSetActiveAccount();
    //   });


    if (window['env']['root'] === '900807') {
      this.lg = true;
      this.user = 'ljl'
      OAuthSettings.access_token = 'ljl@ljl.com';
    }





    // MSAL LOGIN_FAILURE/ACQUIRE_TOKEN_FAILURE subscription DISABLED. Its handler called
    // this.login(resetPasswordFlowRequest) → loginRedirect() on failure — so a failing/looping MSAL
    // interaction on boot could itself trigger a full-page redirect, feeding the production loop.
    // OIDC handles auth; MSAL is inert.
    // this.msalBroadcastService.msalSubject$
    //   .pipe(
    //     filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE || msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE),
    //     takeUntil(this._destroying$)
    //   )
    //   .subscribe((result: EventMessage) => {
    //     if (result.error && result.error.message.indexOf('AADB2C90118') > -1) {
    //       let resetPasswordFlowRequest: RedirectRequest | PopupRequest = {
    //         authority: b2cPolicies.authorities.ResetPWDPolicy.authority,
    //         scopes: [],
    //       };
    //       this.login(resetPasswordFlowRequest);
    //     } else {
    //       if (result.error.message.indexOf('AADB2C90083') >= 0) {
    //         console.log(" error " + result.error.message)
    //         return;
    //       }
    //       const payload = result.payload as AuthenticationResult;
    //       this.authService.instance.setActiveAccount(payload.account);
    //       this.name = payload.account.username;
    //       if (this.name === null || this.name.trim().length <= 0) {
    //         this.lg = false;
    //       } else {
    //         this.lg = true;
    //         this.user = this.name;
    //         OAuthSettings.access_token = this.name;
    //       }
    //     }
    //   });

    // monaco.languages.register({ id: 'ljl' });
    // monaco.languages.setMonarchTokensProvider('ljl', {
    //   tokenizer: {
    //     root: [
    //       [/\bTODO\b/, 'custom-todo'],
    //       [/[a-zA-Z_$][\w$]*/, 'identifier'],
    //       [/"/, 'string', '@string'],
    //     ],
    //     string: [
    //       [/[^"]+/, 'string'],
    //       [/"/, 'string', '@pop']
    //     ]
    //   }
    // });


    // monaco.editor.defineTheme('no-border-theme', {
    //   base: 'vs', // or 'vs-dark' depending on your preference
    //   inherit: true,
    //   rules: [],
    //   colors: {
    //     'editor.background': '#FFFFFF', // Background color of the editor
    //     'editorLineNumber.foreground': '#000000', // Line number color (optional)
    //     'editorCursor.foreground': '#000000', // Cursor color (optional)
    //     'editor.selectionBackground': '#B4D5FE', // Selection color (optional)
    //     'editor.selectionHighlightBorder': 'none', // Remove border for selection highlight
    //     'editorWidget.border': 'none', // Remove border around widgets like hover, autocomplete
    //     'input.border': 'none',// Remove border on input elements (for find/replace box)
    //     'editorLineNumber.activeForeground': 'none', // No highlight on active line number
    //     'editor.lineHighlightBorder': 'none', // No line highlight border
    //     'editor.lineHighlightBackground': 'none', // No background for active line
    //   }
    // });

    // // Apply the new theme to the editor instance
    // // monaco.editor.setTheme('no-border-theme');

    // monaco.languages.registerCompletionItemProvider('ljl', {
    //   provideCompletionItems: function (model, position) {
    //     const word = model.getWordUntilPosition(position);
    //     const range = {
    //       startLineNumber: position.lineNumber,
    //       startColumn: word.startColumn,
    //       endLineNumber: position.lineNumber,
    //       endColumn: word.endColumn
    //     };

    //     // Return custom suggestions ONLY
    //     return {
    //       suggestions: [
    //         {
    //           label: 'tablename',
    //           kind: monaco.languages.CompletionItemKind.Function,
    //           insertText: 'tablename',
    //           range: range
    //         },
    //         {
    //           label: 'tablename.column1',
    //           kind: monaco.languages.CompletionItemKind.Property,
    //           insertText: 'tablename.column1',
    //           range: range
    //         },
    //         {
    //           label: 'tablename.column2',
    //           kind: monaco.languages.CompletionItemKind.Property,
    //           insertText: 'tablename.column2',
    //           range: range
    //         }
    //       ]
    //     };
    //   }
    // });
      

  }


  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    if (

      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      // add your code for handling multiple accounts here
      this.auth.authenticated = true;
      this.authService.instance.setActiveAccount(accounts[0]);
      activeAccount = accounts[0]
    }

    if (activeAccount) {
      this.auth.authenticated = true;
      // const providerOptions: ProviderOptions = {
      //   account: this.authService.instance.getActiveAccount()!,
      //   scopes: protectedResources.graphMe.scopes,
      //   interactionType: InteractionType.Redirect,
      //   endpoint: protectedResources.graphMe.endpoint,
      // };
      // let client = this.gs.getGraphClient(providerOptions);
      // try {
      //   client.api('/me').get().then((me: { [x: string]: null; }) => {
      //     this.user = me['displayName']
      //     this.lg = true;
      //     OAuthSettings.access_token = this.user;

      //   });
      // } catch (exxc) {
      //   console.log(exxc)
      // }
    }


  }



  setLoginDisplay() {
    this.accounts = this.authService.instance.getAllAccounts();
    let active = this.authService.instance.getActiveAccount();



    if (active && active.username != null && active.username.trim().length > 0) {
      this.name = active.username;
      if (this.name === null || this.name.trim().length <= 0) {
        this.lg = false;
      } else {
        this.lg = true;
        this.user = this.name;
        OAuthSettings.access_token = this.name;
      }
    } else {
      for (let a of this.accounts) {
        if (a.username != null && a.username.indexOf('@') > 0) {
          this.authService.instance.setActiveAccount(a);

          this.setLoginDisplay();
        }
      }
      if (!this.lg) {
        this.logout();
      }
    }
  }

  ngOnAfterInit(): void {
    // this.setLoginDisplay();
  }

  public static setTitle(newTitle: string) {
    AppComponent.titleService.setTitle(newTitle);
  }


  showModal(js: any, width, height): Promise<{}> {
    return new Promise((resolve, reject) => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = { 'component': js }
      this.dialog.open(App, dialogConfig);
      resolve(this.dialog)
    });
  }

  // --- OIDC session (from the /login providers) ---
  // The two pages that stand between someone and the editor -- sign-in and checkout -- both
  // need a way THROUGH to the free version. The paywall drawn by baja/datayak/ljlcheckout.js
  // carries one, but lib/subscription.js no longer shows that paywall (showSubscribeGate()
  // sends a non-subscriber straight to free/editor), so neither page offered anything but
  // the paid path.
  get showFreeEntry(): boolean {
    try {
      // Already ON the free-use sign-in page (/login?free=1): that page states the limits and
      // takes the sign-in itself, so the bar would repeat it and its button would link to the
      // page the visitor is standing on.
      if (/(^|[?&])free=1(&|$)/.test('' + window.location.search)) return false;
      const p = ('' + window.location.pathname).toLowerCase();
      // The front page only.
      //
      // It used to appear on /login as well. It was removed from the sign-in page
      // deliberately: that page is the first thing a visitor sees and it should ask one
      // question, not offer a tier alongside it.
      //
      // KNOWN CONSEQUENCE, recorded here rather than discovered later. authGuard routes a
      // signed-out visitor from '/' to /login, so an anonymous visitor no longer meets this
      // bar at all -- the front page it still appears on is one they are redirected away
      // from. The remaining routes to the free tier are the direct /login?free=1 link and
      // the "Continue with the free version" control on the subscription prompt.
      return p === '/' || p === '';
    } catch (e) { return false; }
  }

  // Sign-in first, then the free editor. Navigating straight to /app/free/editor also works
  // -- authGuard would bounce an anonymous visitor to /login and stash the destination -- but
  // setting oidc.returnTo here means the round trip is deliberate rather than a redirect the
  // user has to be lucky to survive. auth-callback.component reads this key after the code
  // exchange and lands the user on it.
  goFreeVersion(): void {
    try { sessionStorage.setItem('oidc.returnTo', '/app/free/editor'); } catch (e) { }
    try {
      const signedIn = !!(this.oidcUser && this.oidcUser.email);
      // ?free=1 tells the login page to describe the FREE TIER rather than run the generic
      // product pitch: the visitor has already chosen, so the page's job is to say what they
      // are getting and take the sign-in.
      window.location.href = window.location.origin + (signedIn ? '/app/free/editor' : '/login?free=1');
    } catch (e) {
      try { window.location.href = window.location.origin + '/login'; } catch (e2) { }
    }
  }

  get oidcUser(): AuthUser | null { return this.oidc.getUser(); }
  // Signed in either through OIDC (a user with an email) or the MSAL path. Used to gate the
  // toolbar menu: an anonymous visitor (the public IP viewer, a free/viewer link) sees the
  // header but cannot open the app menu.
  get isSignedIn(): boolean {
    try {
      const u = this.oidcUser;
      if (u && (u as any).email) return true;
      return !!(this.auth && (this.auth as any).authenticated);
    } catch (e) { return false; }
  }
  get oidcInitials(): string {
    const u = this.oidcUser;
    const s = (u?.name || u?.email || '').trim();
    if (!s) return '?';
    const parts = s.split(/[\s@._-]+/).filter(Boolean);
    return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || s[0].toUpperCase();
  }
  oidcSignOut() {
    // Confirm before signing out so a stray click can't drop the user's session.
    const u = this.oidcUser;
    const who = (u && (u.email || u.name)) ? ('\n\n' + (u.email || u.name)) : '';
    if (!window.confirm('Sign out of Oligo Designer?' + who)) return;
    this.oidc.logout('/login');
  }

  // ---- THE MARK IN THE TOOLBAR ----------------------------------------------
  //
  // One build serves gene.clinic and baja.bio, so the logo cannot be compiled in: the
  // fundraising site should not be wearing the design tool's bull. It is named in
  // assets/env.js, which is a file per deployment and is not replaced by a build:
  //
  //   window.env.brandLogo = 'assets/logos/violet.svg';                 everywhere, or
  //   window.env.brandLogo = { 'gene.clinic': 'assets/logos/violet.svg' };  by hostname
  //
  // A hostname is matched exactly or as a suffix, so one entry covers www. as well. With
  // nothing set, or nothing matching, the bull stays -- a missing entry must never leave
  // an empty square where the mark goes.
  private static readonly DEFAULT_LOGO = 'assets/logos/baja-logo.svg';
  get brandLogo(): string {
    try {
      const v = (window as any)['env']?.['brandLogo'];
      if (typeof v === 'string' && v.trim()) return v.trim();
      if (v && typeof v === 'object') {
        const h = ('' + window.location.hostname).toLowerCase();
        for (const k of Object.keys(v)) {
          const d = ('' + k).toLowerCase().replace(/^\.+/, '');
          if (d && (h === d || h.endsWith('.' + d)) && ('' + v[k]).trim()) return ('' + v[k]).trim();
        }
      }
    } catch (e) { }
    return AppComponent.DEFAULT_LOGO;
  }
  get brandAlt(): string {
    try {
      const v = ('' + ((window as any)['env']?.['brandName'] || '')).trim();
      if (v) return v;
    } catch (e) { }
    return 'BajaBio';
  }

  // ---- THE AUTHORING BUTTONS, IN THE HEADER, FOR ONE ACCOUNT ----------------
  //
  // Record, play back a recording, record the screen to video, and the video tutorials
  // page: four buttons that exist for making demo material rather than for using the
  // application. The editor already carries the first two, but they are wanted from
  // wherever the app happens to be rather than only on the screen that owns them, and the
  // header is the one row present on every screen.
  //
  // Compared trimmed and case-insensitively: the token carries whatever the provider sent,
  // and a stray capital would hide the buttons from the one person meant to see them with
  // nothing on screen to explain why.
  //
  // This is a UI convenience and NOT a permission. The scripts live in baja-apps and the
  // tutorials page is a static asset; anyone who knows their names can reach them, and
  // nothing here is a security control.
  private static readonly AUTHOR_ACCOUNTS = ['jeffmilto@gmail.com'];
  get isAuthorAccount(): boolean {
    try {
      const e = ('' + (this.oidcUser?.email || '')).trim().toLowerCase();
      return !!e && AppComponent.AUTHOR_ACCOUNTS.indexOf(e) >= 0;
    } catch (e) { return false; }
  }
  // The screen that owns a graph registers these when it starts; the header only calls
  // them. Without a registration there is nothing to record, which is the honest state on
  // a route with no canvas on it, and the button says so rather than failing silently.
  private recorderHook(): any {
    try { return (window as any).__bajaRecordHook || null; } catch (e) { return null; }
  }
  get recorderReady(): boolean { return !!this.recorderHook(); }
  startRecording() {
    const h = this.recorderHook();
    if (!h || typeof h.record !== 'function') {
      window.alert('Open the editor or the genome viewer first: recording follows what happens on a canvas.');
      return;
    }
    try { h.record(); } catch (e) { console.warn('record failed', e); }
  }
  // VIDEO, which needs no graph at all. Unlike the two above it does not go through the
  // screen's hook: getDisplayMedia records the TAB, so it works on any route, including
  // ones with no canvas on them, and routing it through a hook would make it unavailable
  // exactly where the header is the only thing present.
  recordVideo() {
    try { IoniScriptEngine.le.exec('manchester/screen-recorder.js'); }
    catch (e) { console.warn('screen recorder failed', e); }
  }
  // Which of the two the menu item is about to do. The recorder publishes its own state,
  // and a menu is built when it opens, so reading it here is enough -- there is nothing to
  // subscribe to and nothing to keep in step.
  get videoRecording(): boolean {
    try { return !!((window as any).__bajaVideoRec && (window as any).__bajaVideoRec.on); }
    catch (e) { return false; }
  }
  playRecording() {
    const h = this.recorderHook();
    if (!h || typeof h.play !== 'function') {
      window.alert('Open the editor first: a recorded script is played back there.');
      return;
    }
    try { h.play(); } catch (e) { console.warn('play failed', e); }
  }

  // TUTORIALS. Everything about which tutorials to offer depends on what is on screen,
  // and the header does not know what that is -- the screen does, through the same hook
  // the Record button uses. So this opens the library and lets it ask.
  // NOT the video page above: those are recordings of a screen, made once and watched.
  // These are recordings of the APPLICATION, saved by whoever did the work, and they play
  // back on the live screen in front of you.
  openSavedTutorials() {
    try { IoniScriptEngine.le.exec('manchester/tutorials.js', { mode: 'browse' }); }
    catch (e) { console.warn('tutorials failed', e); }
  }

  // Account menu → show today's Claude-search count (runs the self-contained lionscript, which
  // reads py/usage/claude-usage-report.py for the signed-in user and pops a summary modal).
  showClaudeUsage() {
    try { IoniScriptEngine.le.exec('baja/manchester/menu/my-claude-usage.js'); }
    catch (e) { console.warn('My Claude usage failed', e); }
  }

  logout() {
    OAuthSettings.access_token = null;
    let adctive = this.authService.instance.getActiveAccount();
    // this.authService.logoutRedirect();
    if (adctive) {
      this.authService.logoutRedirect({
        account: adctive
      });
      clearStorage(adctive);
    }
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    try { if (this.freePollTimer) { clearInterval(this.freePollTimer); this.freePollTimer = null; } } catch (e) { }
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  signUp() {

    if (window['env']['auth'] === 'raredb') {

      let editProfileFlowRequest: RedirectRequest | PopupRequest = {
        authority: rarePolicies.authorities.signUp.authority,
        scopes: [],
      };
      this.login(editProfileFlowRequest)
    } else {
      let editProfileFlowRequest: RedirectRequest | PopupRequest = {
        authority: b2cPolicies.authorities.signUp.authority,
        scopes: [],
      };
      this.login(editProfileFlowRequest)
    }
  }


  login(userFlowRequest?: RedirectRequest | PopupRequest) {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup(userFlowRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {

        let gt = window['env']['grant_type']
        if (!gt) {
          gt = 'authorization_code'
        }
        console.log(" grant type " + gt);
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest, ...userFlowRequest, extraQueryParameters: { grant_type: gt } } as RedirectRequest);
      } else {
        this.authService.loginRedirect(userFlowRequest);

      }
    }
  }


  // async login() {
  //   this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  // msal 2 stuff. 
  // if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
  //   if (this.msalGuardConfig.authRequest) {
  //     this.authService
  //       .loginPopup({
  //         ...this.msalGuardConfig.authRequest,
  //       } as PopupRequest)
  //       .subscribe((response: AuthenticationResult) => {
  //         this.authService.instance.setActiveAccount(response.account);
  //       });
  //   } else {
  //     this.authService
  //       .loginPopup()
  //       .subscribe((response: AuthenticationResult) => {
  //         this.authService.instance.setActiveAccount(response.account);
  //       });
  //   }
  // } else {
  //   if (this.msalGuardConfig.authRequest) {
  //     this.authService.loginRedirect({
  //       ...this.msalGuardConfig.authRequest,
  //     } as RedirectRequest);
  //   } else {
  //     this.authService.loginRedirect();
  //   }
  // }
  // }

  showWidget(js: { wid: any; url: string | URL | null; }): Promise<{}> {
    if (!js.wid && js.url != null) {
      window.location.assign(js.url);
      return new Promise((r, rr) => { })
    }
    var waitForHello = (timeoutms: number) =>
      new Promise<{}>(async (resolve, reject) => {
        var check = () => {
          if ((timeoutms -= 100) < 0) reject("timed out!");
          else setTimeout(check, 10);
        };
        setTimeout(check, 10);
        this.zone.run(() => {
        })

      });
    return waitForHello(100000000);
  }
}
